import React from 'react';
import { Box } from '@common-fe/common-fe';

import { useSetupEmployerMode } from '../hooks';
import { useSaveTypeStore } from '../stores';

import CustomReports from './CustomReports';
import Metrics from './Metrics';

interface Props {
  isDisabled: boolean;
  isReadMode?: boolean;
  isPartnerMode?: boolean;
}
const AdminDashboard: React.FC<Props> = ({ isDisabled, isReadMode, isPartnerMode }) => {
  const { viewMode } = useSetupEmployerMode();
  const { activateSubmitted } = useSaveTypeStore();

  if (isPartnerMode) {
    return <Metrics isDisabled={isDisabled} isShowErrors={activateSubmitted} isEditMode={!viewMode} />;
  }
  return (
    <Box data-testid="reports-section">
      <CustomReports isDisabled={isDisabled} isShowErrors={activateSubmitted} isEditMode={!viewMode} />
      <Box margin={{ top: 'spacing24' }}>
        <Metrics isDisabled={isDisabled} isShowErrors={activateSubmitted} isEditMode={!viewMode} />
      </Box>
    </Box>
  );
};

export default AdminDashboard;
